import { render, staticRenderFns } from "./shopVisitManage.vue?vue&type=template&id=510dae6a&scoped=true"
import script from "./shopVisitManage.vue?vue&type=script&lang=js"
export * from "./shopVisitManage.vue?vue&type=script&lang=js"
import style0 from "./shopVisitManage.vue?vue&type=style&index=0&id=510dae6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510dae6a",
  null
  
)

export default component.exports